import { MetricDisplay } from "../../DashboardPage/DashboardMetrics";
import { PlaylistAddCheck, Schedule, Edit, Block, TimerOutlined } from "@mui/icons-material";
import { round } from "lodash";

interface ProductivityMetricsProps {
  production: number;
  workingTime: number;
  idleTime: number;
}

const ProductivityMetrics = ({ production, workingTime, idleTime }: ProductivityMetricsProps) => {
  return (
    <div
      style={{
        display: "inline-flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <MetricDisplay Icon={PlaylistAddCheck} metricTitle="Production" metricValue={production} />
      <MetricDisplay Icon={Schedule} metricTitle="Total hrs worked" metricValue={round(workingTime + idleTime, 1)} />
      <MetricDisplay Icon={Edit} metricTitle="Working time" metricValue={round(workingTime, 1)} />
      <MetricDisplay Icon={Block} metricTitle="Idle time" metricValue={round(idleTime, 1)} />
      <MetricDisplay
        Icon={TimerOutlined}
        metricTitle="Average QPH"
        metricValue={workingTime === 0 ? 0 : round(production / workingTime, 1)}
      />
    </div>
  );
};

export default ProductivityMetrics;
